<template>
  <div>
    <div class="operate-data">
      <card :cardData="{title:'概况',type:'number',data:summaryData}"></card>

      <div class="convenience white-box" v-if="promotorType==1">
        <div class="title-con">
          <p class="title">快捷操作</p>
        </div>
        <div class="content">
          <el-row class="xmly-table-part" :gutter="20">
            <el-col :span="6" >
              <div class="item list1" @click="goOut('https://shimo.im/sheet/RUJcVXsVISA5BL6z?r=G7E5EE/%E3%80%8C%E7%AB%99%E5%86%85%E7%A7%81%E4%BF%A1%E3%80%8D')">
                <p class="head">申请主站流量</p>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="item list2" @click="auroraIndexUrl">
                <p class="head">发布活动</p>
                <p class="subtit">喜马城市服务商账号要绑定极光账号才能锁定用户</p>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="item list3" @click="openModal">
                <el-button type="text">
                  <p class="head">绑定极光账号</p>
                </el-button>
              </div>
            </el-col>
            <!-- <el-col :span="6" >
              <div class="item list4" @click="goAdvancepayment">
                <p class="tips">{{profit ? 'NEW': '余额不足'}}</p>
                <p class="head">进货款管理</p>
                <p class="subtit">先款后货享50％分成</p>
              </div>
            </el-col> -->
          </el-row>
        </div>
      </div>

      <card :cardData="{title:'实时数据',type:'number', model:'real_time', data:realTimeData}"></card>
      <card @pagSearch="subsiteSearch" :cardData="{title:'我的销售情况',type:'table', data:subsiteData, key:subsiteKey}"></card>
      <card @pagSearch="distributorSearch" v-if="promotorType==1" :cardData="{title:'各分销商销售情况',type:'table', data:distributorData, key:distributorKey}"></card>
      <!-- <card @pagSearch="distributorSearch" v-if="promotorType==1" :cardData="{title:'各分销商锁订单销售情况',type:'table', data:distributorData, key:distributorLockKey}"></card> -->

      <el-dialog
        title="极光账号"
        :visible.sync="dialogVisible"
        size="small">
        <p style="margin-bottom:10px;">您的城市服务商喜马账号当前绑定的极光账号（微信）为：</p>
        <ul style="margin-bottom: 10px;">
          <li style="display: block; padding:20px 10px;" v-if="auroraDatas.length == 0">
            <span style="color: #d82b04; font-size: 13px; padding-left: 10px;">未绑定账号</span>
          </li>
          <li v-for="auroraData in auroraDatas" style="display: inline-block; padding:10px 10px; width: 210px;">
            <span style="width: 32px; height: 32px; overflow: hidden; border-radius: 16px; display: inline-block; vertical-align: middle;">
              <img :src="auroraData.headImageUrl" width="32"/>
            </span>
            <span style="color: #d88c04; font-size: 13px; padding-left: 10px;">{{ `${auroraData.nickName}` }}</span>
          </li>
        </ul>
        <p>如账号有误，请<a :href="addUrl" target="_blank">点击添加</a>，绑定新的极光账号。如需让员工或分销商使用，请在极光中为分销商创建子账号。</p>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
        </span>
      </el-dialog>
    </div>
    <!--通知中心-->
    <div class="notice-center">
      <div class="notice-header">
        <h2>最新通知</h2>
        <router-link class="more-notice" to="/partnernotice/index">查看更多</router-link>
      </div>
      <div class="notice-body">
        <router-link :class="{read:!item.read}" tag="li" to="/partnernotice/index" :key="item.id" v-for="item in recentList">{{item.title}}</router-link>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import { opertionSummary, realtimeInfo, distributorSaleInfo, subsiteSaleInfo, auroraAccounts,recent } from 'api'
  import card from 'components/card'
  export default {
    data(){
      return {
        summaryData:{},
        realTimeData:{},
        subsiteData:{},
        distributorData:{},
        // subsiteKey:['name', 'salesAmount', 'commission', 'paidOrderCount', 'paidUserCount'],
        subsiteKey:['name', 'salesAmount', 'commission', 'paidOrderCount'],
        // distributorKey:['name', 'salesAmount', 'commission', 'paidOrderCount', 'paidUserCount'],
        distributorKey:['name', 'salesAmount', 'commission', 'paidOrderCount'],
        // distributorLockKey:['name','lockSalesAmount','lockCommission','lockPaidOrderCount','lockPaidUserCount'],
        // distributorLockKey:['name','lockSalesAmount','lockCommission','lockPaidOrderCount'],
        dialogVisible: false,
        addUrl: '',
        auroraDatas: [],
        recentList:[],
        profit: true //预付款余额是否充足
      }
    },
    components: {
      card
    },
    computed: {
      ...mapGetters([
        'uid',
        'promotorType',
        'accountState'
      ])
    },
    created() {
      let vis = this;
      recent().then(res=>{
        if(res.ret ==0){
          vis.recentList =  res.data;
        }
      }).catch(()=>{});
      opertionSummary().then(res=>{
        if(res.ret ==0){
          vis.summaryData = res.data
        }
      }).catch(()=>{});
      realtimeInfo().then(res=>{
        if(res.ret == 0){
          vis.realTimeData = res.data
        }
      }).catch(()=>{});
      if(vis.promotorType==1){
        vis.distributorSearch()
      }
      vis.subsiteSearch()
    },
    methods:{
      distributorSearch() {
        let vis = this;
        distributorSaleInfo(arguments[0]).then(res=>{
          if(res.ret ==0){
            vis.distributorData = res.data
          }
        }).catch(()=>{})
      },
      subsiteSearch() {
        let vis = this;
        subsiteSaleInfo(arguments[0]).then(res=>{
          if(res.ret ==0){
            vis.subsiteData = res.data
          }
        }).catch(()=>{})
      },
      auroraIndexUrl() {
        let url = location.origin.indexOf('.test.') >= 0 ? 'http://aurora.test.ximalaya.com/back/config/backend/index' : 'http://aurora-plat.ximalaya.com/config/backend/index';
        window.open(url, '_blank')
      },
      goOut (url) {
        window.open(url, '_blank')
      },
      getToken(name){
        let value = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
        return value ? ( value[2].split('&').length == 2 ? value[2].split('&')[1] : '' ) : '';
      },
      openModal(){
        this.addUrl = location.origin.indexOf('.test.') >= 0 ? 'http://m.test.ximalaya.com/passport/auth/12/authorize/?fromUri=' + encodeURIComponent('http://aurora.test.ximalaya.com/back/config/backend/qrCodeBinding?bindingId=' + this.uid + '&cookie=' + this.getToken('4&_token')) : 'http://m.ximalaya.com/passport/auth/12/authorize/?fromUri=' + encodeURIComponent('http://aurora-plat.ximalaya.com/config/backend/qrCodeBinding?bindingId=' + this.uid + '&cookie=' + this.getToken('1&_token'));

        auroraAccounts().then(res=>{
          if(res.ret == 0){
            this.auroraDatas = res.data;
            this.dialogVisible = true;
          }
        }).catch(()=>{
          this.$message({
            type:'error',
            message:'服务异常！'
          });
        });
      },
      goAdvancepayment () {
        // 跳转预付款页面
        this.$router.push('/advancepayment/manager')
      }
    }
  }
</script>

<style lang="scss" scoped>
  .operate-data{
    float: left;
  }
  .notice-center{
    float: left;
    margin-left: 10px;
    width: 290px;
    height:244px;
    overflow: hidden;
    background: #fff;
    .notice-header{
      padding:17px 20px;
      border-bottom:1px solid #E8E8E8;
      display:flex;
      justify-content: space-between;
      align-items: center;
      h2{
        font-size: 20px;
        color: #000000;
        font-weight: 600;
      }
      .more-notice{
        font-size: 14px;
        color: #F86442;
      }
    }
    .notice-body{
      padding: 20px 20px 10px;
      li{
        font-size: 14px;
        color: #666666;
        padding-bottom: 10px;
        padding-left:10px;
        position: relative;
        overflow:hidden;
        white-space: nowrap;
        text-overflow:ellipsis;
      &:before{
          content: "";
          width: 5px;
          height: 5px;
          border-radius: 50%;
          position: absolute;
          left: 0;
          top:7px;
          background: #DDDDDD;
        }
        &.read{
          &:before{
             background: #EA3A1B;
          }
        }
        &:hover{
          opacity: 0.7;
          cursor: pointer;
        }
      }
    }
  }
  .card{
    margin-bottom:10px;
  }
  .convenience{
    // width: 720px;
    padding: 0 0 20px;
    background: #fff;
    margin-bottom: 10px;
    .title-con {
      border-bottom: 1px solid #dfe6ec;
      min-height: 60px;
    }
    .title {
      height: 20px;
      //line-height: 54px;
      font-size: 20px;
      color: #333;
      padding: 17px 20px 0px 20px;
      margin: 0;
    }
    .xmly-table-part {
      padding-left: 0px;
      // display: table;
      // width: 100%;
      // margin: 42px 0 20px 0;
      .item {
        display: table-cell;
        vertical-align: middle;
        text-align: center;
        position: relative;
        width: 165px;
        height: 100px;
        // margin-right: 10px;
        cursor: pointer;
        .tips {
          position: absolute;
          left: 0;
          top: 0;
          background-color: #f66449;
          display: inline-block;
          border-radius: 0 0 5px 0;
          color: #fff;
          font-size: 12px;
          padding: 3px;
        }
      }
      .list1 {
        background-color: #7AD188;
      }
      .list2 {
        background-color: #72BFD3;
      }
      .list3 {
        background-color: #7E9CD5;
      }
      .list4 {
        background-color: #DD7FC9;
      }
      .head {
        font-size: 18px;
        color: #fff;
      }
      .subtit {
        font-size: 12px;
        color: #fff;
        margin-top: 3px;
      }
    }
  }
</style>





// WEBPACK FOOTER //
// index.vue?712be240